export default __webpack_public_path__ + "static/media/Ellipse1.75432ef6.svg";